import React, { useState, useRef } from "react";
import { useNavigate } from "react-router-dom";

const audioList = [
  { id: 1, title: "1. Alcoholics Anonymous (AA Tamil Big Book- Audio compilation)-Serenity Prayer", file: "/audio/chapter1.m4a" },
  { id: 2, title: "2. Alcoholics Anonymous (AA Tamil Big Book- Audio compilation )- Foreword", file: "/audio/chapter2.m4a" },
  { id: 3, title: "3. Alcoholics Anonymous (AA Tamil Big Book- Audio compilation)-Chapter 1 - Bill's story", file: "/audio/chapter3.m4a" },
  { id: 4, title: "4. Alcoholics Anonymous (AA Tamil Big Book- Audio compilation)- Chapter 2- There is a Solution", file: "/audio/chapter4.m4a" },
  { id: 5, title: "5. Alcoholics Anonymous (AA Tamil Big Book- Audio compilation)- Chapter 3- More about Alcoholism", file: "/audio/chapter5.m4a" },
  { id: 6, title: "6. Alcoholics_Anonymous_AA_Tamil_Big_Book-_Audio_compilation_-_Chapter_4_-_We_Agnostics_256KBPS", file: "/audio/chapter6.mp3" },
  { id: 7, title: "7. Alcoholics Anonymous (AA Tamil Big Book- Audio compilation) - Chapter 5 - How IT Works", file: "/audio/chapter7.m4a" },
  { id: 8, title: "8. Alcoholics Anonymous (AA Tamil Big Book- Audio compilation) - Chapter 6- Into Action", file: "/audio/chapter8.m4a" },
  { id: 9, title: "9. Alcoholics Anonymous (AA Tamil Big Book- Audio compilation) - Chapter 7 - Working With Others", file: "/audio/chapter9.m4a" },
  { id: 10, title: "10. Alcoholics Anonymous (AA Tamil Big Book- Audio compilation) - Chapter 8- To Wives", file: "/audio/chapter10.m4a" },
  { id: 11, title: "11. Alcoholics_Anonymous_AA_Tamil_Big_Book-_Audio_compilation_-_Chapter_9_-_The_Family_Afterward_128KBPS", file: "/audio/chapter11.mp3" },
  { id: 12, title: "12. Alcoholics_Anonymous_AA_Tamil_Big_Book-_Audio_compilation_-_Chapter_10_-_To_Employers_256KBPS", file: "/audio/chapter12.mp3" },
  { id: 13, title: "13. Alcoholics_Anonymous_AA_Tamil_Big_Book-_Audio_compilation_-_Chapter_11-_A_Vision_For_You_128KBPS", file: "/audio/chapter13.mp3" },
];

export default function BigBookAudio() {
  const [activeId, setActiveId] = useState(null);
  const audioRefs = useRef({});
  const navigate = useNavigate();

  const handlePlay = (id) => {
    // stop all audios
    Object.values(audioRefs.current).forEach((audio) => {
      if (audio) audio.pause();
    });

    if (activeId === id) {
      setActiveId(null);
    } else {
      setActiveId(id);

      setTimeout(() => {
        audioRefs.current[id]?.play();
      }, 100);
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-100 to-blue-300 p-6">
      {/* 🔙 BACK BUTTON */}
      <button
        onClick={() => navigate(-1)}
        className="mb-4 bg-gray-800 text-white px-4 py-2 rounded-lg"
      >
        ← Back
      </button>

      <h1 className="text-3xl font-bold text-center mb-8">
        Big Book Tamil Audio
      </h1>

      <div className="max-w-3xl mx-auto space-y-4">
        {audioList.map((audio) => (
          <div
            key={audio.id}
            className={`
              p-5 rounded-2xl shadow-md transition-all duration-300
              ${
                activeId === audio.id
                  ? "bg-blue-200 scale-[1.02]"
                  : "bg-white hover:bg-blue-50"
              }
            `}
          >
            {/* HEADER */}
            <div className="flex justify-between items-center">
              <h3 className="font-semibold text-gray-800">{audio.title}</h3>

              <button
                onClick={() => handlePlay(audio.id)}
                className="bg-blue-500 text-white px-4 py-1 rounded-lg"
              >
                {activeId === audio.id ? "Stop" : "Play"}
              </button>
            </div>

            {/* INLINE AUDIO PLAYER */}
            {activeId === audio.id && (
              <div className="mt-4">
                <audio
                  ref={(el) => (audioRefs.current[audio.id] = el)}
                  src={audio.file}
                  controls
                  className="w-full"
                />
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
}
